var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAtualizar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9,16.3c-0.8-0.5-1.8-0.3-2.3,0.5l-0.1,0.1c-0.6-8.3-7.6-14.9-16-14.9C7.6,1.9,0.4,9.1,0.4,18s7.2,16.1,16.1,16.1 c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-6.4,0-11.6-5.2-11.6-11.6S10.1,6.4,16.5,6.4c5.9,0,10.8,4.5,11.5,10.2 c-0.5-0.7-1.5-0.8-2.2-0.3c-0.8,0.5-1,1.6-0.5,2.3l3.3,5c0.4,0.6,1,0.9,1.7,0.9c0.7,0,1.3-0.4,1.7-0.9l3.3-5 C35.9,17.8,35.6,16.8,34.9,16.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAtualizar01);
export default __webpack_public_path__ + "static/media/ico-atualizar-01.0276a5a28c6f3cfe563c85767ccdb593.svg";
export { ForwardRef as ReactComponent };